import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";
// tslint:disable
export const yammer_poll: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg viewBox="0 0 240 240" focusable="false" {...rest}>
      <path
        fill={iconColor}
        stroke={iconColor}
        fillRule="evenodd"
        d="M180 30v45H45V30h135zm-15
      30V45H60v15h105zm-15 30v45H45V90h105zm-15 30v-15H60v15h75zm75 30v45H45v-45h165zm-15
      30v-15H60v15h135zM30 210h195v15H15V15h15v195z"
      ></path>
    </svg>
  );
};
